<template>
  <div>
   <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
          <div class="text-xs-left">
          <v-badge  v-on:click="Shownotificationbar" right color="red">
           <span slot="badge"  ><small>{{notifications.length}}</small></span>
          <v-icon
          color="white"
          right 
          @click="Shownotificationbar"
          >
          fa fa-bell
          </v-icon>
          </v-badge>
            
        </div>
        
     </div>
</template>
<script>
import NotificationModel from '@/api/service/NotificationService';
import NotificationBox from './NotificationBox.vue'
export default {
    components: {
      NotificationBox
    },
    data()  { 
      
      return {
        dialog:false,
        shownotification:true,
        notificationContent:'',
        drawer:false,
        notifications:[

         {"id":123,"title":"Show Temp",type:"I"},
         {"id":123,"title":"Warning",type:"W"},
         {"id":123,"title":"Crititcal",type:"C"}

       ]

// notifications:{

// }
       
      }
    },
    
    
  computed: {
    
  },
    created: function() {
      NotificationModel.findAll({})
            .then(response => {
                this.setNotification(response)                
            }).catch(error => {
                console.log(error)
        }); 

    },


    mounted: function(){
        NotificationModel.findAll({})
            .then(response => {
                setNotification(response)                
            }).catch(error => {

        }); 
    },
    methods: {
        setNotification($x){
        this.notifications = $x;
        },
        showInfo($item)
        {
        this.notificationContent=$item
         this.dialog=true 
         setTimeout(this.invisibleDialog,6000)
        },
        invisibleDialog() {
          this.dialog=false
        },
 Shownotificationbar()
 {
   //this.showNotification=!this.showNotification
   //this.$store.commit('SET_SHOW_NOTIFICATION', this.showNotification)
   this.$parent.$parent.$emit('NotificationListClicked')
 }


    },
    


    
  }


</script>